import * as React from "react";
import * as ReactDOM from "react-dom";
import { LWPComponent } from "VSSPreview/Flux/Components/LWP";
import { ISecurityPageViewProps } from "TFS/Security/Common/Security.Controls.Props";

export function renderResourceSecurityUX(container: any, props: ISecurityPageViewProps) {
    ReactDOM.render(<ResourceSecurityView {...props} />, container);
}

export class ResourceSecurityView extends React.Component<ISecurityPageViewProps> {

    constructor(props: ISecurityPageViewProps, context: any) {
        super(props, context);
    }

    public render(): JSX.Element {
        return (
            <div>                              
                <LWPComponent
                    dependencies={["ms.vss-admin-web.security-view-common-content"]}
                    wrappedType="ms.vss-admin-web.security-page-view-component"
                    securityViewTitle={this.props.securityViewTitle}
                    permissionSetId={this.props.permissionSetId}
                    permissionSetToken={this.props.permissionSetToken}
                    resourceId={this.props.resourceId}
                    resourceType={this.props.resourceType}
                    resourceName={this.props.resourceName}
                /> 
            </div>
        );
    }
}